import { render } from "./FacebookCampaignOverviewChart.vue?vue&type=template&id=666d72c5&scoped=true&ts=true"
import script from "./FacebookCampaignOverviewChart.vue?vue&type=script&lang=ts"
export * from "./FacebookCampaignOverviewChart.vue?vue&type=script&lang=ts"

import "./FacebookCampaignOverviewChart.vue?vue&type=style&index=0&id=666d72c5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666d72c5"]])

export default __exports__